export const INITIALIZE_VIEW = 'INITIALIZE_VIEW';
export type InitializeViewAction = {
	type: typeof INITIALIZE_VIEW;
};
export const initializeView = (): InitializeViewAction => ({
	type: INITIALIZE_VIEW,
});
